import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
import ProductHero from '../components/ProductHero';

const V2About = () => {
  useSEO({
    title: 'About Keystone | Practitioners first',
    description: 'Keystone Strategic Consultants is built around practical experience of managing complex projects, programmes and lifecycle within demanding operational environments. Videra grew from that experience.',
    path: '/about',
  });

  return (
    <div data-testid="v2-about">
      <ProductHero
        eyebrow="About"
        title="Experience came first. The technology followed."
        body={(
          <>
            <p>Keystone Strategic Consultants is built around practical experience of managing complex projects, programmes and lifecycle within demanding operational environments.</p>
            <p>That experience includes senior lifecycle responsibility within major Tier-1 contracting environments supporting complex UK healthcare estates — from large acute hospital environments to smaller community facilities.</p>
            <p className="text-slate-900 font-medium">Working in those environments reinforces an important principle:</p>
            <p className="text-blue-700 italic">You cannot manage projects properly without understanding why they exist — and you cannot manage lifecycle properly without controlling the projects that deliver it.</p>
          </>
        )}
        testid="about-hero"
      />

      <section className="py-20 md:py-24 bg-slate-50 border-y border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold mb-4">Why Videra exists</p>
          <div className="text-base lg:text-lg text-slate-700 leading-relaxed space-y-4">
            <p>Videra grew from that experience.</p>
            <p>We repeatedly encountered fragmented information, competing lifecycle priorities, inconsistent processes, manual reporting, evidence gaps and risks becoming visible too late.</p>
            <p>Instead of accepting those problems as inevitable, we started building practical digital solutions around them.</p>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-slate-900">Practitioners first.</h2>
          <div className="mt-6 text-base lg:text-lg text-slate-700 leading-relaxed space-y-4">
            <p>We don&rsquo;t believe in designing operational technology from a distance.</p>
            <p>Videra is shaped around the realities of the people delivering the work.</p>
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href="https://demo.videra.app/explore" className="inline-flex items-center gap-2 bg-slate-900 text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors">
              Explore Videra <ArrowRight className="w-4 h-4" />
            </a>
            <Link to="/investors" className="text-sm font-medium text-slate-600 hover:text-slate-900 self-center" data-testid="about-investors-link">
              Investors & strategic partners →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default V2About;
